import { Countries, CrmCountries } from "types/Models/countries";
import { CrmProfileResponse } from "types/Models/profile";
import { emptyApi } from "./emptyApi";
import { makeFormData } from "utils/makeFormData";
import { ParsedCOIResponse } from "types/Models/onboarding";

const extendedApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getCrmUser: build.query<CrmProfileResponse, { crmAccessToken: string }>({
      query: ({ crmAccessToken }) => {
        return {
          url: `/api/inkle/users/verify-user-from-crm/?payload=${crmAccessToken}`,
        };
      },
    }),

    getCountriesData: build.query<Countries[], void>({
      query: () => "api/inkle/company/countries-data/",
    }),

    createGroupAndEntities: build.mutation({
      query: ({ payload }) => {
        return {
          url: "/api/inkle/company/group/entities/",
          method: "POST",
          body: makeFormData({
            ...payload,
            entity_data: JSON.stringify(payload.entity_data),
          }),
        };
      },
    }),

    createSeasonSummary: build.mutation({
      query: ({ groupId, entityId, payload }) => {
        return {
          url: `/api/inkle/bookkeeping/group/${groupId}/entity/${entityId}/season_summary`,
          method: "POST",
          body: payload,
        };
      },
    }),

    onBoardingUpdateSeasonSummary: build.mutation({
      query: ({ groupId, entityId, payload }) => {
        return {
          url: `/api/inkle/bookkeeping/group/${groupId}/entity/${entityId}/onboarding/season_summary/`,
          method: "PUT",
          body: payload,
        };
      },
    }),
    getCrmCountriesData: build.query<CrmCountries[], void>({
      query: () => "api/inkle/serviceteams/foreign_service-providers/countries",
    }),
    parseCOI: build.mutation<
      ParsedCOIResponse,
      {
        file: File;
      }
    >({
      query: ({ file }) => {
        const formData = new FormData();
        formData.append("file", file);

        return {
          url: `/api/inkle/company/extract-coi/`,
          method: "POST",
          body: formData,
        };
      },
    }),
    applyInviteCoupon: build.mutation<
      { is_valid_coupon: boolean },
      { uuid: string; couponCode: string }
    >({
      query: ({ uuid, couponCode }) => {
        return {
          url: `api/inkle/users/verify-coupon/`,
          method: "post",
          body: { profile_id: uuid, coupon_code: couponCode },
        };
      },
      invalidatesTags: ["USER_COUPON_CODE"],
    }),
  }),
});

export const {
  useGetCrmUserQuery,
  useGetCountriesDataQuery,
  useCreateGroupAndEntitiesMutation,
  useCreateSeasonSummaryMutation,
  useOnBoardingUpdateSeasonSummaryMutation,
  useGetCrmCountriesDataQuery,
  useParseCOIMutation,
  useApplyInviteCouponMutation,
} = extendedApi;
